import { InjectableClass } from '@fino/lib-injection';
import { addSecuritiesComponent } from './addSecurities.component';

const uuidv1 = require('uuid/v1');

class AddSecuritiesService extends InjectableClass {
  constructor($q, $uibModal) {
    'ngInject';
    super({ $q, $uibModal });
  }

  open(user = null) {
    return this.$uibModal.open({
      component: addSecuritiesComponent.name,
      size: 'modal-lg',
      windowClass: 'add-securities-modal',
    }).result;
  }

  initEmptySecurity() {
    return {
      currency: 'EUR',
      securityId: uuidv1(),
    };
  }
}

export default AddSecuritiesService;



// WEBPACK FOOTER //
// ./src/app/common/ui/addSecurities/addSecurities.service.js